(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["apex-product-information"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
 const opener = event.target.closest('[data-apex-size-open]');
 if (opener) { const dialog = document.querySelector('.apex-size-dialog'); if (dialog && !dialog.open) dialog.showModal(); }
 if (event.target.closest('[data-apex-size-close]')) event.target.closest('dialog').close();
});
  } catch(e) { console.error(e); }
})();

})();
